import { useEffect, useState } from "react"
import ShareButton from "./ShareButton"
import { Contact } from "@models/contact.model";
import accomodationService from "@services/accomodation.service";
import sessionStorageService from "@services/sessionStorage.service";
import { useLocation } from "react-router-dom";

export default function WhatsAndShareButtons(props: {title: string|undefined}){
    const location = useLocation()
    const [contact, setContact] = useState<Contact| undefined>(undefined);

    useEffect(()=>{

        async function getContacts(id: string) {
          try {
              const response = await accomodationService.getContact(id)
              sessionStorage.setItem('contact', JSON.stringify(response));
              setContact(response)     
          } catch (error) {
              alert(error);
          }
        }
        
        const cached = sessionStorageService.getContactSS()
        if (cached) {     
            setContact(cached);
        } else {
            const qrCodeId = location.pathname.split("/")[1];
            getContacts(qrCodeId);
        }

    },[])

    return(
        <div className="icon-wrapper">
            <a
              href={`https://wa.me/${contact?.whatsapp?.replace(/\D/g, '')}`}
              target="_blank"
              rel="noopener noreferrer"
              role="button"
            >
              <img src="/images/whatsapp.png" alt="" className="icon_float" />
            </a>
            <ShareButton title={props?.title}/>
        </div>
    )
}